import * as url from "./urlHelper";
import {
    httpClientAgent,
    httpClientDocument,
    httpClientUser
} from "./httpClient"
//import {JobPageRequest} from "./model/jobPageRequest";

//TODO: copiar los demás servicios en: adjuvo-frontend/src/helper/fakebackend_helper.js

export const postLogin = (form: object) => httpClientAgent.create(url.POST_FAKE_LOGIN, form);
// export const getUserInfo = () => httpClientAuth.get(url.POST_INFO_USER);
// export const getInterviewers = () => httpClientAuth.get(url.GET_INTERVIEWERS);

//Profile
export const getUsers = (groupId: string) => httpClientAgent.get(url.GET_USERS.replace("{group_id}", groupId));
export const getSchedule = (brokerId: string) => httpClientAgent.get(url.GET_SCHEDULES.replace("{broker_id}", brokerId));
export const updateSchedule = (brokerId: string,  body: any) => httpClientAgent.put(url.UPDATE_SCHEDULES.replace("{broker_id}", brokerId), body);
export const gerInfoUser = (id: string) => httpClientAgent.get(url.GET_INFO_USER.replace("{broker_id}", id))

// export const getUser = (id: number) => httpClientAuth.get(url.URL_USERS, {user_id: id});
// export const updateUser = (id: number, body: any) => httpClientAuth.update(url.URL_USERS+"?id_user="+id.toString(), body);
// export const getUserOther = (id: number) => httpClientAuth.get(url.GET_USER.replace("{id_user}", id.toString()));
// export const getConfigUser = () => httpClientAuth.get(url.GET_USER_INFO);

// export const getUserConfiguration = (id: number) => httpClientAuth.get(url.EDIT_USER_CONFIGURATION.replace("{id_user_configuration}", id.toString()));
// export const postUserConfiguration = (form: any) => httpClientAuth.create(url.URL_USER_CONFIGURATION, form);
// export const updateUserConfiguration = (id: number, form: any) => httpClientAuth.update(url.EDIT_USER_CONFIGURATION.replace("{id_user_configuration}", id.toString()), form);

// //Roles
// export const getRolesAll = () => httpClientAuth.get(url.URL_ROLES);

// //Company and Organization
// export const getOrganization = (id: number) => httpClientAuth.get(url.GET_ORGANIZATION.replace("{id_organization}", id.toString()));
// export const getCompany = (id: number) => httpClientAuth.get(url.GET_COMPANY.replace("{id_company}", id.toString()));


export const getConversationsNotJoined = () => httpClientAgent.get(url.GET_CONVERSATIONS_NOT_JOINED);
export const postTwilioIdentityToken = (identity: string, group: number) => httpClientAgent.create(url.GET_CHAT_TOKEN_TWILIO, {identity: identity, group_id: group});
export const postConversationJoin = (body: any) => httpClientAgent.create(url.GET_CONVERSATIONS_JOIN, body);
export const postMediaTwilio = (body: any) => httpClientAgent.create(url.GET_MEDIA_TWILIO, body);

export const postSendMedia = (form: any) => httpClientDocument.create(url.ADD_SEND_MEDIA, form);
export const postSendMessage = (body: any) => httpClientAgent.create(url.ADD_SEND_MESSAGE, body);
export const postChangeAgent = (body: any) => httpClientAgent.create(url.UPDATE_AGENT, body);
export const getStatusChannelAgent = (id: string, orgId: string) => httpClientAgent.get(url.GET_STATUS_AGENT.replace("{id_channel}", id).replace("{id_org}", orgId));
export const updateAttributes = (id: string, body: any) => httpClientAgent.patch(url.UPDATE_ATTRIBUTE_CHANNEL.replace("{id_channel}", id), body);
export const renameContact = (body: any) => httpClientAgent.patch(url.UPDATE_NAME_CONTACT, body);

export const getTemplates = (id: string) => httpClientAgent.get(url.GET_TEMPLATES.replace("{id_group}", id));
export const postTemplate = (id: string, body: any) => httpClientAgent.create(url.POST_TEMPLATES.replace("{id_channel}", id), body);

export const postAssignUser = (id:string, body: any) => httpClientAgent.patch(url.POST_ASSIGN_USER.replace("{conversation_sid}", id), body);
export const updateNotes = (id:string, body: any) => httpClientAgent.patch(url.UPDATE_NOTES.replace("{conversation_sid}", id), body);
export const getNotes = (id:string, orgId: string, whatsapp: string) => httpClientAgent.get(url.GET_NOTES.replace("{conversation_sid}", id).replace("{org_id}", orgId).replace("{whatsapp}", whatsapp));